import request from '@/utils/request'


export function fetchMessageBoard() {
  return request({
    url: '/MessageBoard/active_list',
    method: 'post'
  })
}

export function addMessageBoard(data) {
  return request({
    url: '/MessageBoard/add',
    method: 'post',
    data: {
      Data: data
    }
  })
}

